import React, { useState } from 'react';
import Button from '@/react/libraries/ButtonList/Button';

const List = ({ data, name, onButtonClick }) => {
	const [activeButton, setActiveButton] = useState(name);

	const handleButtonClick = (buttonTxt) => {
		setActiveButton(buttonTxt);
		onButtonClick(buttonTxt);
	};

	return (
		<div className="flex flex-col h-full overflow-auto [&>a]:px-3 [&>a]:py-4 [&>a:hover]:bg-primary-50 [&>a]:font-medium">
			{data.map((text, i) => (
				<Button 
					key={i} 
					text={text} 
					onButtonClick={()=>handleButtonClick(text)} 
					isActive={text === activeButton} 
				/>
			))}
		</div>
	);
};

export default List;

